import { FC } from "react";

interface RATServiceOrderResolutionDetailsProps {
  notes?: string;
  result?: string;
}

export const RATServiceOrderResolutionDetails: FC<
  RATServiceOrderResolutionDetailsProps
> = ({ notes, result }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="flex justify-start">
        <img
          src={
            result === "Passed" ? "/passed-stamp.png" : "/failed-stamp.png"
          }
          className="h-24"
          alt=""
        />
      </div>
      <div className="pt-6">
        <div className="mt-4">
          <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
            <div className="grid grid-cols-3 gap-4">
              <div>
                <span className="block text-sm font-light text-gray-700">
                  Result
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {result || "N/A"}
                </div>
              </div>
              <div className="col-span-3">
                <span className="block text-sm font-light text-gray-700">
                  Notes
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {notes || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RATServiceOrderResolutionDetails;
